import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { SERVICES_DATA } from '../data/servicesData';
import PageHeader from './PageHeader';
import './ServiceDetail.css';

const publicUrl = process.env.PUBLIC_URL || '';
const SERVICE_IMAGES = {
  feasibility: `${publicUrl}/images/feasibility.jpg`,
  contracts: `${publicUrl}/images/contracts.jpg`,
  management: `${publicUrl}/images/program.jpg`,
  capabilities: `${publicUrl}/images/developing.jpg`,
};

const ServiceDetail = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({ name: '', email: '', company: '', message: '' });

  const service = id ? SERVICES_DATA[id] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Lead submission logic can be wired here
  };

  if (!service) {
    return (
      <div className="service-detail-wrapper">
        <div className="service-detail-not-found">
          <h2>Service not found</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-wrapper">
      <PageHeader title={service.title} backgroundImage={SERVICE_IMAGES[id]} />

      <div className="service-detail-container">
        <div className="service-detail-body">
          <main className="service-detail-main">
            <ul className="service-detail-list">
              {service.details.map((item, index) => (
                <li key={index} className="service-detail-list-item">
                  <span className="service-detail-check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </main>

          <aside className="service-detail-sidebar">
            <div className="service-detail-card">
              <h3 className="service-detail-card-title">Request Information</h3>
              <form className="service-detail-form" onSubmit={handleSubmit}>
                <label className="service-detail-label">
                  Name
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="service-detail-input"
                    required
                  />
                </label>
                <label className="service-detail-label">
                  Email
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="service-detail-input"
                    required
                  />
                </label>
                <label className="service-detail-label">
                  Company
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="service-detail-input"
                  />
                </label>
                <label className="service-detail-label">
                  Message
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="service-detail-textarea"
                    rows={4}
                  />
                </label>
                <button type="submit" className="service-detail-submit">Send Request</button>
              </form>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
